
import Vue from 'vue'
import { formatDisplayDateTime } from '@/util/formatters'
import JcdcUtilityMenuFooter from '@/components/jcdc/JcdcUtilityMenuFooter.vue'
import JcdcUtilityMenuLinks from '@/components/jcdc/JcdcUtilityMenuLinks.vue'
import { VBtn, VIcon, VList, VMenu, VToolbar, VToolbarItems } from 'vuetify/lib'
import { userInfo, utilityItem } from '@/util/navUtilities'
import dayjs from 'dayjs'

export default Vue.extend({
  name: 'JcdcUtilityMenu',
  components: {
    JcdcUtilityMenuFooter,
    JcdcUtilityMenuLinks,
    VBtn,
    VIcon,
    VList,
    VMenu,
    VToolbar,
    VToolbarItems,
  },
  props: {
    userInfo: { type: Object as () => userInfo, required: true },
    utilityList: { type: Array as () => utilityItem[], default: (): [] => [] },
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      width: '300px',
      height: '80px',
      menuOpen: this.value,
    }
  },
  computed: {
    attachID() {
      return `_${Math.random().toString(36).substr(2, 9)}`
    },
  },
  methods: {
    formatDisplayDateTime,
    dayjs,
  },
})
